<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.43301 1.82181L11.567 1.82181L15.134 8.00001L11.567 14.1782L4.43301 14.1782L0.866025 8.00001L4.43301 1.82181Z" stroke="currentColor" stroke-width="1.5"/>
</svg>
